import { Grid,Tooltip, Typography} from '@material-ui/core';
import ViewListIcon from '@material-ui/icons/ViewList';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import styled from 'styled-components';
import colors from '../../../../config/theme/colors'
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';

const ViewModuleIconCustom = styled(ViewModuleIcon)`
    fill: ${colors.grey.regular};
    cursor: pointer;
    background:none;
    &.active{
        fill: ${colors.blue.darker.hue300};
        cursor: inherit;
    }
`;
const ViewListIconCustom = styled(ViewListIcon)`
    fill: ${colors.grey.regular};
    cursor: pointer;
    background:none;

    &.active{
        fill: ${colors.blue.darker.hue300};
        cursor: inherit;
    }
`;

function ChangeView(props){
    let {views} = props;
    const useStylesBootstrap = makeStyles(theme => ({
        arrow: {
            color: colors.blue.darker.hue300,
        },
        tooltip: {
            backgroundColor: colors.blue.darker.hue300,
            fontSize: 14,
        },
    }));

    const classes = useStylesBootstrap();
    
    const BootstrapTooltip = (props) =>{
        return <Tooltip arrow classes={classes} {...props} />;
    }

    return(
        <Grid container justifyContent="flex-end" alignItems="center">
            <Typography variant='body1' style={{marginBottom: 4}}>{props.t('products.list.view')} : </Typography>
            <BootstrapTooltip title="Voir en cartes" className={clsx(classes.tooltip)}>
                <ViewModuleIconCustom 
                style={{ fontSize: 30 }} 
                className={views.current === "card" ? 'active': null}
                onClick={views.current === "card" ? null : () => props.handleViews('card')}
                />
            </BootstrapTooltip>
            <BootstrapTooltip title="Voir en liste" className={clsx(classes.tooltip)}>
                <ViewListIconCustom 
                style={{ fontSize: 30, marginLeft: 8 }} 
                className={views.current === "table" ? 'active': null}
                onClick={views.current === "table" ? null : () => props.handleViews('table')}
                />
            </BootstrapTooltip>
        </Grid>
    )
}

export default withTranslation()(ChangeView);